@use "foundation/_colors.scss";

.edit-field-container {
  position: relative;
  padding: .75em 1em;
  margin-top: 1em;
  border-radius: .5em;

  font-size: 1.25em;
  font-weight: 700;

  color: colors.$primary-text-color;
  background-color: colors.$secondary-background-color;

  .button-container {
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    color: white;

    .edit-field-button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      background-color: colors.$primary-brand-color;
      cursor: pointer;

      svg {
        height: 40%;
        width: 3em;
      }
    }

    .final-button {
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
}

.selectable-field {
  cursor: pointer;
}

.selectable-field:active {
  background-color: colors.$quaternary-text-color;
}
